import {Form, InputNumber, Modal,  App, Row, Col, DatePicker, Space      } from 'antd'        
import React, { useEffect, useState } from 'react'
import classes from './expense.module.css'
import Icon from '../../cpn/Icon';
import { useFeiyongAddMutation, useFYaddtijiaoMutation, } from '../../store/DianShangYeWuApi';
import OCRTextArea from '../../cpn/OCRTextArea';
import ClientSelect from '../../system/client/ClientSelect';
import ClientBankSelect from '../../system/client/ClientBankSelect';
import UploadPic from '../../cpn/UploadPic';
import dayjs from 'dayjs';
import Asterisk from '../../cpn/Asterisk';
import DocumentRule from '../../cpn/DocumentRule';
import ExpenseNodeAdd from './ExpenseNodeAdd';
import ArapTypeSelect from '../../cpn/ArapTypeSelect';
function ExpenseAddReportEdit(props) {
    const { message } = App.useApp();
    // 若 props 中企业 id/名 为空或 0，则从本地存储读取
    const qy_id = (props.qy_id === 0 || props.qy_id === null || props.qy_id === undefined || props.qy_id === '')
        ? (JSON.parse(localStorage.getItem('jtg-caiwu_qy_id')) ?? props.qy_id)
        : props.qy_id;
    const qy_name = (props.qy_name === '' || props.qy_name === undefined)
        ? (JSON.parse(localStorage.getItem('jtg-caiwu_qy_name')) ?? props.qy_name)
        : props.qy_name;

    const [open,setOpen] = useState(false);
    const [info,setInfo] = useState({
        'fy_price':  props.dsbzd_kh_id,//保存团队客户id
        'fy_uid': '',
        'fy_uname': '',
        'fy_content': '',
        'fy_bzd_id': '',
        'fy_qy_id': '',
        'fy_qy_name': '',
        'fy_kh_id': '',
        'fy_kh_name': '',
        'fy_type_id':props.dsbzd_dscp_id,//保存团队客户类型id
        'fy_type_name': props.dsbzd_dscp_name,//保存团队客户类型名称
        'fy_amount': '',
        'fy_bzd_xuhao': '',
        'fy_bzd_name': '',
        'fy_date': props.dsbzd_date ? dayjs(props.dsbzd_date) : undefined,
        'fy_bzd_date_end': '',
        'fy_num': props.dsbzd_kh_name,//保存团队客户名称
        'fy_name': '',
        'fy_bzd_date': '',
        'fy_khyhzh_id': '',
        'fy_khyhzh_name': '',
        'fy_image_name': '',
        'fy_image_file': '',
        'fy_bm_id': props.dsbzd_bm_id,  
        'fy_bm_name': props.dsbzd_bm_name,
        'fy_state': '1',
        'fy_zflx': ''
    })
    const [form] = Form.useForm();
    const [add] = useFeiyongAddMutation();
    useEffect(() => {
        // 确保fy_date有默认值，同时更新其他相关字段
        if (!info.fy_date || props.dsbzd_date !== info.fy_date || props.dsbzd_date_end !== info.fy_date_end) {
            setInfo(prevState => ({
                ...prevState,
                fy_date: props.dsbzd_date || new Date().toISOString().split('T')[0],
                fy_date_end: props.dsbzd_date_end || new Date().toISOString().split('T')[0],
                fy_bzd_name: props.dsbzd_name || prevState.fy_bzd_name,
                fy_bzd_danhao: props.dsbzd_danhao || prevState.fy_bzd_danhao,
                fy_bzd_id: props.dsbzd_id || prevState.fy_bzd_id
            }))
        }
    }, [props, info.fy_date, info.fy_date_end])

    // 当Modal打开时设置表单值
    useEffect(() => {
        if (open) {
            if (props.dsbzd_date && props.dsbzd_date_end) {
                form.setFieldsValue({
                    fy_bzd_name: props.dsbzd_danhao + ' ' + props.dsbzd_name,
                })
            }
            // 设置表单字段的初始值
            form.setFieldsValue({
                fy_price: 0.01,
                fy_num: 1,
                fy_amount: ''
            })
        }
    }, [open, props, form])

    //费用提交
    const [addtijiao] = useFYaddtijiaoMutation()
    const [isSubmitting, setIsSubmitting] = useState(false)
    return (
        <>
            <Icon type='add' onClick={() => {setOpen(true)}} />
            <Modal
                open={open} 
                onCancel={() => {setOpen(false)}}
                width={1330}
                form={form}
                footer={null}
            >
                <Form
                    form={form}
                    className={classes.form}
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                    initialValues={{
                        fy_date: props.dsbzd_date ? dayjs(props.dsbzd_date) : undefined,
                        fy_bm_id: props.dsbzd_bm_id ? props.dsbzd_bm_id : undefined,
                        fy_bm_name: props.dsbzd_bm_name ? props.dsbzd_bm_name : undefined,
                    }}
                >
                     <Row style={{width:"1280px"}}>
                       <Col span={4} className={classes.row_top_left} style={{borderTop:'3px solid #3366cc',borderLeft:'3px solid #3366cc'}}></Col>
                       <Col span={16} className={classes.row_top_middle} style={{color:'#3366cc',borderTop:'3px solid #3366cc'}}>费用单</Col>
                       <Col span={4} className={classes.row_top_right} style={{borderTop:'3px solid #3366cc',borderRight:'3px solid #3366cc'}}></Col>
                        {/* 第一行 */}
                        <Col span={2} className={classes.col_top_label} style={{borderLeft:'3px solid #3366cc',color:'#3366cc'}}>团队名称</Col>
                       <Col span={6}  className={classes.col_top_input} style={props.dsbzd_name ? {} : {padding: '15px'}}>
                           {props.dsbzd_name}
                       </Col>  
                       <Col span={2} className={classes.col_top_label} >团队客户类型</Col>
                       <Col span={6}  className={classes.col_top_input}>
                            {props.dsbzd_dscp_id && props.dsbzd_dscp_name && <div>{props.dsbzd_dscp_name}</div>}
                       </Col>  
                       <Col span={2}  className={classes.col_top_label} >团队客户</Col>
                       <Col span={6}  className={classes.col_right_input}  style={{borderRight:'3px solid #3366cc'}}>
                            {props.dsbzd_kh_id && props.dsbzd_kh_name && <div>{props.dsbzd_kh_name}</div>}
                       </Col> 
                       {/* 第二行 */}
                       <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #3366cc'}}><Asterisk color='red'/> 日期</Col>
                       <Col span={6}  className={classes.col_middle_input}>
                           <Form.Item name='fy_date' noStyle>
                               <DatePicker 
                                   placeholder='请选择日期' 
                                   onChange={(value) => {
                                       setInfo(prevState => ({ ...prevState, fy_date: value ? value.format('YYYY-MM-DD') : '' }))
                                   }}
                                   style={{ width: '100%' }}
                               />
                           </Form.Item>
                       </Col>
                       <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/>金额</Col>
                       <Col span={6}  className={classes.col_middle_input}>
                           <Form.Item name='fy_amount' noStyle>
                               <InputNumber 
                                   placeholder='请输入金额' 
                                   onChange={(value) => {
                                       setInfo(prevState => ({ ...prevState, fy_amount: value }))
                                   }}
                                   style={{ width: '100%' }}
                                   min={0.01}
                               />
                           </Form.Item>
                       </Col>
                       <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 部门</Col>
                       <Col span={6}  className={classes.col_middle_right_input}   style={{borderRight:'3px solid #3366cc'}}>
                           {props.dsbzd_bm_name}
                       </Col>
                       {/* 第三行 */}
                       <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #3366cc'}}><Asterisk color='red'/> 费用客户</Col>
                       <Col span={6}  className={classes.col_middle_input}>
                            <ClientSelect
                                name='fy_kh_name'
                                placeholder='请选择费用客户'
                                onChange={(value,label) => {
                                    setInfo(prevState => ({ ...prevState, fy_kh_id: value, fy_kh_name: label }))
                                }}
                                style={{width: '230px'}}
                                formStyle={{marginBottom: 0,width: '100%'}}
                                qy_id={qy_id}
                                yh_id={props.yh_id}
                                defaultId={info.fy_kh_id}
                                wrapperCol={{span:24}}
                                clientAdd={true}
                            />
                       </Col>
                       <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 银行账户</Col>
                       <Col span={14}  className={classes.col_middle_input} style={{borderRight:'3px solid #3366cc'}}>
                           <ClientBankSelect
                               name='fy_khyhzh_name'
                               placeholder='请选择银行账户'
                               onChange={(value,label) => {
                                   setInfo(prevState => ({ ...prevState, fy_khyhzh_id: value, fy_khyhzh_name: label }))
                               }}
                               style={{ width: '100%' }}
                               formStyle={{marginBottom: 0,width: '100%'}}
wrapperCol={{span:24}}
                                qy_id={qy_id}
                                yh_id={props.yh_id}
                                defaultId={info.fy_khyhzh_id}
                               kh_id={info.fy_kh_id}
                           />
                       </Col>                       
                       {/* 第四行       */}
                       <Col span={2} className={classes.col_middle_label} style={{borderLeft:'3px solid #3366cc'}}><Asterisk color='red'/> 往来类型</Col>
                       <Col span={6}  className={classes.col_middle_input}>
                            <ArapTypeSelect 
                                documentType='expense' 
                                onChange={(value) => {
                                    setInfo(prevState => ({ ...prevState, fy_zflx: value }))
                                }}
                                name='fy_zflx'
                                required={true}
                                style={{marginBottom: 0}}
                                wrapperCol={{span:24}}
                            />
                       </Col>                                   
                       <Col span={2} className={classes.col_middle_label}>备注</Col>
                       <Col span={6}  className={classes.col_middle_input}>
                            <Form.Item name='fy_content' noStyle>
                               <OCRTextArea
                                   value={info.fy_content}
                                   onChange={(e) => {
                                       setInfo(prevState => ({ ...prevState, fy_content: e.target.value }))
                                   }}
                                   language="chi_sim"
                               />
                           </Form.Item>
                       </Col> 
                       <Col span={2} className={classes.col_middle_label}>转账记录</Col>
                       <Col span={6}  className={classes.col_middle_input} style={{borderRight:'3px solid #3366cc'}}>
                       </Col>                                   
                       {/* 第五行       */}
                       <Col span={2} className={classes.col_middle_label} style={{borderLeft:'3px solid #3366cc'}}>编号/状态</Col>
                       <Col span={6}  className={classes.col_middle_input}>                            
                       </Col>                                   
                       <Col span={2} className={classes.col_middle_label}>附件</Col>
                       <Col span={14}  className={classes.col_bottom_input} style={{borderRight:'3px solid #3366cc'}}>
                           <UploadPic
                               name='fy_image'
                               onChange={(e,f) => {
                                   setInfo(prevState => ({ ...prevState, fy_image_file: e, fy_image_name: f }))
                               }}
                               maxCount={5}
                               style={{ width: '100%' }}
                               formStyle={{marginBottom: 0,width: '100%'}}
                           />
                       </Col>        
                       {/* 第六行 */}
                       <Col span={24} className={classes.bottom_row}>
                            <ExpenseNodeAdd
                                qy_id={qy_id}
                                qy_name={qy_name}
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                                user_id={props.yh_id}
                            />
                       </Col>
                   </Row>   
                   <Row>
                        <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                            <DocumentRule/>
                            <Space size={20}>
                                <Icon type='save' onClick={() => {                                    
                                    if(info.fy_amount === ''){
                                        message.error('请输入金额');
                                        return;
                                    }
                                    if(info.fy_kh_id === ''){
                                        message.error('请选择客户');
                                        return;
                                    }
                                    if(info.fy_date === ''){
                                        message.error('请选择日期');
                                        return;
                                    }
                                    if(info.fy_khyhzh_id === ''){
                                        message.error('请选择银行账户');
                                        return;
                                    }
                                    if(props.fy_bm_id === ''){
                                        message.error('请选择部门');
                                        return;
                                    }
                                    if(info.fy_zflx === ''){
                                        message.error('请选择往来类型');
                                        return;
                                    }
                                    add({
                                        'fy_price': props.dsbzd_kh_id,
                                        'fy_uid': props.yh_id,
                                        'fy_uname': props.yh_name,
                                        'fy_content': info.fy_content,
                                        'fy_bzd_id': props.dsbzd_id,
                                        'fy_qy_id': qy_id,
                                        'fy_qy_name': qy_name,
                                        'fy_kh_id': info.fy_kh_id,
                                        'fy_kh_name': info.fy_kh_name,
                                        'fy_type_id': props.dsbzd_dscp_id,
                                        'fy_type_name': props.dsbzd_dscp_name,
                                        'fy_amount': info.fy_amount,
                                        'fy_bzd_xuhao': '',
                                        'fy_bzd_name': props.dsbzd_name,
                                        'fy_date': info.fy_date ? info.fy_date:props.dsbzd_date,
                                        'fy_bzd_date_end': props.dsbzd_date_end,
                                        'fy_num': props.dsbzd_kh_name, 
                                        'fy_name': '',
                                        'fy_bzd_date': props.dsbzd_date,
                                        'fy_khyhzh_id': info.fy_khyhzh_id,
                                        'fy_khyhzh_name': info.fy_khyhzh_name,
                                        'fy_image_name': info.fy_image_name?info.fy_image_name:'',
                                        'fy_image_file': info.fy_image_file?info.fy_image_file:'',
                                        'fy_bm_id': props.dsbzd_bm_id,
                                        'fy_bm_name': props.dsbzd_bm_name,
                                        'fy_state': '1',
                                        'fy_zflx': info.fy_zflx,
                                        'spdd_sp_id': '14',
                                        'spdd_sp_name': '财务管理',
                                        'spdd_spgg_id': '20',
                                        'spdd_spgg_name': '费用单',
                                        'spdd_spgg_price': '0.1',
                                        'spdd_state': '支出'
                                    }).then(res => {
                                        if(res.data.Status==='success'){
                                            setOpen(false);
                                            message.success('新增成功');
                                            form.resetFields();  
                                        }else{
                                            message.error('新增失败！' + res.data.Message);
                                        }
                                    })     
                                }}/>
                                <Icon type='reset' onClick={() => {
                                    form.resetFields()
                                    setInfo(prevState => ({ 
                                        ...prevState, 
                                        fy_price: props.dsbzd_kh_id, 
                                        fy_num:1, 
                                        fy_amount:'', 
                                        fy_content:'',                             
                                        fy_type_id:'', 
                                        fy_type_name:'', 
                                        fy_kh_id:'', 
                                        fy_kh_name:'', 
                                        fy_bm_id:props.dsbzd_bm_id,
                                        fy_bm_name:props.dsbzd_bm_name,
                                        fy_date:props.dsbzd_date ? dayjs(props.dsbzd_date) : undefined,
                                        qy_id: qy_id,
                                        qy_name: qy_name,
                                        fy_zflx: ''
                                    }))
                                    // 重置后重新设置表单字段的默认值
                                    form.setFieldsValue({
                                        fy_price: props.dsbzd_kh_id,
                                        fy_num: 1,
                                        fy_amount: ''
                                    })
                                }}/>   
                                <Icon
                                    type='submit'
                                    title='提交'
                                    disabled={isSubmitting}
                                    style={isSubmitting ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                    onClick={() => {
                                        // 如果正在提交中，直接返回
                                        if (isSubmitting) {
                                            return;
                                        }
                                        
                                        // 先进行验证
                                        if(info.fy_amount === ''){
                                            message.error('请输入金额');
                                            return;
                                        }
                                       
                                        if(info.fy_kh_id === ''){
                                            message.error('请选择客户');
                                            return;
                                        }
                                        if(info.fy_khyhzh_id === ''){
                                            message.error('请选择银行账户');
                                            return;
                                        }                                       
                                        if(props.dsbzd_bm_id === ''){
                                            message.error('请选择部门');
                                            return;
                                        }
                                        if(info.fy_zflx === ''){
                                            message.error('请选择往来类型');
                                            return;
                                        }
                                        if(info.fy_date === ''){
                                            message.error('请选择日期');
                                            return;
                                        }
                                        
                                        // 验证通过后，设置提交状态
                                        setIsSubmitting(true);
                                        addtijiao({
                                            'fy_type_id': props.dsbzd_dscp_id,      
                                            'fy_type_name': props.dsbzd_dscp_name,
                                            'fy_amount': info.fy_amount,
                                            'fy_qy_id': qy_id,
                                            'fy_qy_name': qy_name,
                                            'fy_num': props.dsbzd_kh_name,
                                            'fy_zflx': info.fy_zflx,
                                            'fy_uid': props.yh_id,
                                            'fy_uname': props.yh_name,
                                            'fy_name': props.dsbzd_name,
                                            'fy_date': info.fy_date?info.fy_date:props.dsbzd_date,
                                            'fy_kh_id': info.fy_kh_id,
                                            'fy_kh_name': info.fy_kh_name,
                                            'fy_price': props.dsbzd_kh_id,
                                            'fy_content': info.fy_content,  
                                            'fy_bzd_id': props.dsbzd_id,
                                            'fy_bzd_name': props.dsbzd_name,
                                            'fy_bzd_date': props.dsbzd_date,
                                            'fy_bzd_xuhao': '',
                                            'fy_bzd_date_end': props.dsbzd_date_end,
                                            'fy_khyhzh_id': info.fy_khyhzh_id,
                                            'fy_khyhzh_name': info.fy_khyhzh_name,
                                            'fy_bm_id': props.dsbzd_bm_id,
                                            'fy_bm_name':props.dsbzd_bm_name,
                                            'fy_image_name': info.fy_image_name?info.fy_image_name:'',
                                            'fy_image_file': info.fy_image_file?info.fy_image_file:'',
                                            'fy_state': '1',
                                        }).then(res => {
                                            if(res.data.Status==='success'){
                                                message.success('提交成功');
                                                setIsSubmitting(false);
                                                setOpen(false);
                                                
                                                form.resetFields();  
                                            }else{
                                                message.error('提交失败！' + res.data.Message);
                                            }
                                        })     
                                    }}
                                />  
                            </Space>
                        </Col>
                   </Row>
                </Form>
            </Modal>

        </>
    )
}

export default ExpenseAddReportEdit